module.exports = __webpack_public_path__ + "img/collection-weddingRings@2x.2af0c27.webp";